import type { ANNLayerSnapshot } from "./ANNTypes";
import { LayerType } from "src/common/managers/Types";
import type { LayerInfo } from "src/common/managers/Types";
import type { FeatureCollection } from "geojson";
export function snapshotLayer(layer: LayerInfo): ANNLayerSnapshot | undefined {
   if (
      layer.type !== LayerType.ImageOverlay &&
      layer.type !== LayerType.GeoJSON_Line &&
      layer.type !== LayerType.GeoJSON_Polygon &&
      layer.type !== LayerType.GeoJSON_Point
   ) {
      return undefined;
   }
   if (!layer.geoJson?.features?.length) {
      return undefined;
   }
   if (layer.type === LayerType.ImageOverlay) {
      const firstFeature = layer.geoJson.features[0];
      if (!firstFeature?.properties?._imgUrl) {
         return undefined;
      }
   }
   const baseSnapshot: ANNLayerSnapshot = {
      layerId: layer.layerId,
      datasetName: layer.datasetname,
      filename: layer.filename,
      type: layer.type,
      styling: structuredClone(layer.styling),
      visible: layer.visible,
      hasNoDataBehind: layer.hasNoDataBehind,
      geoJson: structuredClone(layer.geoJson as FeatureCollection),
      propertiesInGeoJson: layer.propertiesInGeoJson ? [...layer.propertiesInGeoJson] : undefined,
      propertiesToDisplay: layer.propertiesToDisplay ? structuredClone(layer.propertiesToDisplay) : undefined,
   };
   return baseSnapshot;
}
